/* eslint-disable no-unused-expressions */
import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Button, Icon, Select, Spin } from "antd";
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import { SplitAccountModel } from "../../../../models/split_account";
import { alertify, handleApiExceptions } from "../../../../app_methods";
import { SplitAccountsConfigWrapper } from "./styles";
import "./index.scss";

const hunderedPercentage = 100;

const splitValueValidator = (_rule, value, split_type, callback) => {
  if (!value) return callback();

  if (Number(value) === 0 && !isNaN(Number(value))) {
    return callback("Enter Valid Value");
  }

  const regex = /^([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)$/;
  if (!regex.test(value)) {
    return callback("Enter Valid Value");
  }

  if (split_type === "percentage") {
    if (value > 100) callback("Enter Valid Percentage");
  }

  const maxDigitsRegex = /^\d{16}/;
  if (maxDigitsRegex.test(value)) {
    return callback("Split value must be less than 16 digits.");
  }
  callback();
};

const handleSplitValueInput = (val) => {
  if (!val) return;
  if (typeof val !== "string") val.toString();
  const updatedVal = val?.indexOf(".") >= 0 ? val.slice(0, val.indexOf(".") + 4) : val;
  return updatedVal;
};

const SplitAccountList = (props) => {
  const {
    splitConfig,
    splitType,
    splitAccounts,
    selectedPriorities,
    getFieldDecorator,
    handleSelectItem,
    handleSelectPriority,
    remove,
    selectedAccounts,
    handleFieldChange,
    handleSearchAccount,
    isAccountsLoading,
  } = props;
  const validations = SplitAccountModel.validations;

  const possiblePriorities = Array.from({ length: splitConfig.length }, (_, i) => i + 1);
  const availablePriorities = possiblePriorities.filter((num) => {
    return !selectedPriorities.includes(num);
  });

  return splitConfig.map((item, index) => {
    const lowestPriorityAcc = splitConfig?.find(
      (item) => item?.priority === splitConfig.length || splitConfig.length === 1
    );

    const renderSplitValue = () => {
      const SplitValue = (
        <Form.Item label={"Split Value"} className="value ml-2">
          {getFieldDecorator(`config[${index}]['split_value']`, {
            initialValue: item?.split_value ? parseFloat(item?.split_value).toFixed(3) : "0.000",
            rules: [
              { required: true, message: "Split value is mandatory" },
              {
                validator: (rule, value, callback) => {
                  splitValueValidator(rule, value, splitType, callback);
                },
              },
            ],
            normalize: handleSplitValueInput,
            onChange: (e) => handleFieldChange("split_value", index, e.target.value),
          })(
            <Input
              prefix={splitType === "flat" ? `₹` : ""}
              autoComplete="off"
              suffix={splitType === "percentage" ? "%" : null}
              placeholder={"Enter split value"}
              type="number"
            />
          )}
        </Form.Item>
      );

      if (splitType === "percentage") {
        return SplitValue;
      } else {
        if ((!item?.id && item?.priority !== splitConfig.length) || lowestPriorityAcc?.id !== item?.id) {
          return SplitValue;
        } else {
          return <span className="value-rest ml-2">Rest of The Amount</span>;
        }
      }
    };

    return (
      <div className="line-item" key={index}>
        <span className="index">{index + 1}.</span>
        {/* account selection */}
        <Form.Item label={"Account"} className="account">
          {getFieldDecorator(`config[${index}]['id']`, {
            initialValue: item?.id,
            validateTrigger: ["onChange", "onBlur"],
            rules: [
              {
                required: true,
                message: "Split account is mandatory",
              },
            ],
            onChange: (value) => handleSelectItem(index, value),
          })(
            <Select
              loading={isAccountsLoading}
              placeholder="Select split account"
              className="w-100"
              allowClear
              showSearch
              onSearch={handleSearchAccount}
              filterOption={(input, option) => {
                const inputL = input.toLowerCase();
                const optionArr = option?.key.toLowerCase()?.split("|") ?? [];
                if (optionArr[0].includes(inputL)) return true;
                if (optionArr[1].includes(inputL)) return true;
                return false;
              }}
            >
              {splitAccounts.map((obj, i) => {
                return (
                  <Select.Option
                    key={`${obj?.account_number}|${obj?.account_holder_name}`}
                    value={obj?.id}
                    disabled={selectedAccounts.includes(obj?.id)}
                  >
                    <div className="account-select">
                      <span className="option-number-text">{obj?.account_number}</span>
                      <span className="option-name-text">{obj?.account_holder_name}</span>
                    </div>
                  </Select.Option>
                );
              })}
            </Select>
          )}
        </Form.Item>
        {/* split value */}
        {renderSplitValue()}

        {/* priority selection */}
        {splitType === "flat" ? (
          <Form.Item label={"Split Priority"} className="priority ml-2">
            {getFieldDecorator(`config[${index}]['priority']`, {
              initialValue: item?.priority ? item?.priority : splitAccounts.length === 1 ? 1 : undefined,
              rules: validations.priority(splitType),
              onChange: (value) => handleSelectPriority(index, value),
            })(
              <Select allowClear placeholder="Select priority">
                {availablePriorities?.map((item, index) => {
                  return (
                    <Select.Option key={index} value={item}>
                      {item}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
        ) : null}
        {/* -------------- hidden fields -------------------- */}
        {getFieldDecorator(`config[${index}]['rest_of_amount']`, {
          initialValue: lowestPriorityAcc?.id === item.id ? true : false,
        })(<Input autoComplete="off" hidden />)}
        {/* -------------- hidden fields -------------------- */}
        {splitConfig?.length > 1 ? (
          <div className="add-button">
            <Icon
              className="dynamic-delete-button"
              style={{ fontSize: "24px", color: "#f5222d" }}
              type="minus-circle-o"
              onClick={() => remove(index)}
            />
          </div>
        ) : null}
      </div>
    );
  });
};

let SplitAccountConfigurationForm = (props) => {
  const { visible, form, merchantId, split_settlement_type, cva_id, virtualAccount, toggleConfigureModal } = props;
  const { getFieldDecorator } = form;
  const validations = SplitAccountModel.validations;
  const listRef = useRef(null);

  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [isAccountsLoading, setIsAccountsLoading] = useState(false);
  const [isRetrieving, setIsRetrieving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [splitType, setSplitType] = useState("flat");
  const [selectedPriorities, setSelectedPriorities] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [splitAccounts, setSplitAccountData] = useState([]);
  const [splitAccountsIdArr, setSplitAccountsIdArr] = useState(new Set([]));
  const [splitConfig, setSplitConfig] = useState([]);

  const totalSplitPercentage = Array.isArray(splitConfig)
    ? splitConfig?.reduce((total, obj) => {
        return parseFloat(total) + parseFloat(obj?.split_value || 0);
      }, 0)
    : 0;
  const restSplitPercentage = splitType === "percentage" ? (hunderedPercentage - totalSplitPercentage).toFixed(3) : 0.0;

  useEffect(() => {
    if (visible) {
      form.resetFields();
      fetchSplitAccounts();
    }
  }, [visible]);

  const fetchSplitAccounts = async (search_by = "") => {
    setIsAccountsLoading(true);
    const queryData = {
      merchant_id: merchantId,
      pageSize: 10,
      current: 1,
      approval_status: 2,
    };
    if (search_by) {
      queryData.search_by = search_by;
    }

    const response = await SplitAccountModel.list(queryData);
    if (!response.success) {
      handleApiExceptions(response);
      setIsAccountsLoading(false);
      return;
    }
    setIsAccountsLoading(false);
    const result = response?.data?.results || [];
    const resData = result?.map((obj) => ({
      id: obj?.id,
      split_value: obj?.split_value,
      priority: obj?.priority,
      account_number: obj?.account_number,
      account_holder_name: obj?.account_holder_name,
    }));

    const newSplitAccounts = cloneDeep(splitAccounts);
    const newSplitAccountsIdArr = new Set(splitAccountsIdArr);
    for (let obj of resData) {
      if (!newSplitAccountsIdArr.has(obj?.id)) {
        newSplitAccounts.push(obj);
        newSplitAccountsIdArr.add(obj?.id);
      }
    }
    setSplitAccountData(newSplitAccounts);
    setSplitAccountsIdArr(newSplitAccountsIdArr);

    if (!initialLoadDone) {
      fetchSplitConfiguration(newSplitAccounts, newSplitAccountsIdArr);
      setInitialLoadDone(true);
    }
  };

  const fetchSplitConfiguration = async (splitAccounts, splitAccountsIdArr) => {
    setIsRetrieving(true);
    const queryData = {
      custom_virtual_account_id: split_settlement_type === "CVA" ? cva_id : null,
    };
    const response = await SplitAccountModel.getConfiguration(queryData);

    if (!response.success) {
      handleApiExceptions(response);
      setIsRetrieving(false);
      return;
    }

    setIsRetrieving(false);
    const data = response?.data?.split_accounts ?? [];
    const split_accounts =
      data?.length > 0
        ? data.map((obj) => {
            const split_value = data[0].split_type === "flat" && obj?.split_value === 0 ? 1 : obj?.split_value;
            return {
              id: obj?.id,
              split_value: split_value,
              priority: obj?.priority,
              rest_of_amount: obj?.priority === data?.length,
              account_holder_name: obj?.account_holder_name,
              account_number: obj?.account_number,
            };
          })
        : [
            {
              id: undefined,
              split_value: undefined,
              priority: undefined,
              rest_of_amount: true,
              account_holder_name: "",
              account_number: "",
            },
          ];
    setSplitConfig(split_accounts);

    const splitType = data[0]?.split_type || "flat";
    setSplitType(splitType);

    form.setFieldsValue({
      split_type: splitType,
      config: split_accounts?.map((obj) => ({
        id: obj?.id,
        split_value: obj?.split_value,
        priority: obj?.priority,
        rest_of_amount: obj?.priority === data?.length,
      })),
    });

    const selectedPriorities = [];
    const selectedAccounts = [];
    split_accounts?.forEach((obj) => {
      selectedPriorities.push(obj?.priority || undefined);
      if (obj?.id) selectedAccounts.push(obj?.id);
    });

    // add to main accounts array if configured account is not there
    const newSplitAccounts = cloneDeep(splitAccounts);
    const newSplitAccountsIdArr = new Set(splitAccountsIdArr);

    for (let obj of split_accounts) {
      if (!splitAccountsIdArr.has(obj?.id)) {
        newSplitAccounts.push(obj);
        newSplitAccountsIdArr.add(obj?.id);
      }
    }
    setSplitAccountData(newSplitAccounts);
    setSplitAccountsIdArr(newSplitAccountsIdArr);

    setSelectedPriorities(selectedPriorities);
    setSelectedAccounts(selectedAccounts);
  };

  const handleFieldChange = (field, index, value) => {
    const updatedSplitConfig = cloneDeep(splitConfig);

    if (field === "priority") {
      updatedSplitConfig[index].priority = value;
      if (value === splitConfig?.length) {
        updatedSplitConfig[index].split_value = 1;
        updatedSplitConfig[index].rest_of_amount = true;
      }
    } else if (field === "id") {
      updatedSplitConfig[index].id = value;
    } else {
      updatedSplitConfig[index][field] = value;
    }

    setSplitConfig(updatedSplitConfig);
  };

  const handleChangeSplitType = (value) => {
    setSplitType(value);
    resetSomeFields("typeChange", splitConfig);
  };

  const resetSomeFields = (type, config) => {
    let updatedSplitConfig = [];

    if (type === "typeChange") {
      updatedSplitConfig = config.map((obj) => {
        return { ...obj, split_value: "", priority: "", rest_of_amount: false };
      });
      form.resetFields();
      setSplitConfig(cloneDeep(updatedSplitConfig));
      setSelectedPriorities([]);
    }

    if (type === "remove-flat") {
      updatedSplitConfig = config.map((obj) => {
        return { ...obj, priority: "", rest_of_amount: false };
      });
      let pathArr = [];
      updatedSplitConfig.forEach((obj, i) => {
        pathArr = [...pathArr, `config[${i}]['priority']`];
      });
      form.resetFields(pathArr);

      setSplitConfig(cloneDeep(updatedSplitConfig));
      setSelectedPriorities([]);
    }
  };

  const configureSplitAccounts = async (values) => {
    setIsSubmitting(true);

    const response =
      split_settlement_type === "MVA"
        ? await SplitAccountModel.configure({ ...values })
        : await SplitAccountModel.configure_cva({ ...values, cva_id: virtualAccount?.id });

    if (!response.success) {
      handleApiExceptions(response);
      setIsSubmitting(false);
      return;
    }

    alertify("Success", "Split Accounts Configuration Successful", "success");
    setIsSubmitting(false);
    toggleConfigureModal();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) return;

      const config = [];

      values?.config?.forEach((obj, i) => {
        const configObj = {
          id: obj?.id,
          split_value: obj?.split_value,
          priority: obj?.priority || null,
          rest_of_amount: obj?.rest_of_amount,
        };

        if (values?.split_type === "flat" && obj?.rest_of_amount) {
          configObj.split_value = null;
        }

        config.push(configObj);
      });

      configureSplitAccounts({ split_type: splitType, config });
    });
  };

  const scrollToBottom = () => {
    const currentHeight = listRef.current.scrollHeight;
    listRef.current.scrollTo({
      top: currentHeight,
      behavior: "smooth",
    });
  };

  const remove = (index) => {
    const newSplitConfig = cloneDeep(splitConfig);
    newSplitConfig.splice(index, 1);

    if (splitType === "flat") {
      resetSomeFields("remove-flat", newSplitConfig);
    } else {
      setSplitConfig(newSplitConfig);
    }
  };

  const add = () => {
    setSplitConfig([
      ...splitConfig,
      {
        id: undefined,
        split_value: 1,
        priority: splitType === "flat" ? splitConfig?.length + 1 : "",
        rest_of_amount: splitType === "flat" ? true : false,
      },
    ]);

    if (splitType === "flat") {
      setSelectedPriorities([...selectedPriorities, splitConfig?.length + 1]);
    }

    setTimeout(() => {
      scrollToBottom();
    }, 100);
  };

  const handleSelectItem = (index, value) => {
    const updatedSelectedAccount = cloneDeep(selectedAccounts);
    updatedSelectedAccount[index] = value;
    setSelectedAccounts(updatedSelectedAccount);
    handleFieldChange("id", index, value);
  };

  const handleSelectPriority = (index, value) => {
    const updatedPriorities = [...selectedPriorities];
    updatedPriorities[index] = value;
    setSelectedPriorities(updatedPriorities);
    handleFieldChange("priority", index, value);
  };

  const handleSearchAccount = debounce(async (searchValue) => {
    if (!searchValue) {
      return;
    }

    // Check if the search term already exists in options
    const optionExists = splitAccounts.some((option) => option.value === searchValue);

    if (!optionExists) {
      fetchSplitAccounts(searchValue);
    }
  }, 500);

  const disableSave = () => {
    if (splitType === "percentage" && restSplitPercentage != 0) {
      return true;
    }
    if (isSubmitting) {
      return true;
    }

    return false;
  };

  return (
    <SplitAccountsConfigWrapper splitType={splitType} onSubmit={onSubmit}>
      <Spin spinning={isRetrieving}>
        <Form.Item label={"Split Type"} className="split-type ml-2">
          {getFieldDecorator(`split_type`, {
            rules: validations.split_type,
          })(
            <Select
              id="select-split-type"
              placeholder="Select Split Type"
              className=""
              onChange={handleChangeSplitType}
              autoComplete="off"
              prefix={<Icon type="profile" />}
            >
              <Select.Option key="percentage" value="percentage">
                Percentage
              </Select.Option>
              <Select.Option key="flat" value="flat">
                Flat
              </Select.Option>
            </Select>
          )}
        </Form.Item>

        <div className="split-accounts-list">
          <div className="list" ref={listRef}>
            <SplitAccountList
              splitConfig={splitConfig}
              splitType={splitType}
              splitAccounts={splitAccounts}
              selectedPriorities={selectedPriorities}
              getFieldDecorator={getFieldDecorator}
              handleSelectItem={handleSelectItem}
              handleSelectPriority={handleSelectPriority}
              remove={remove}
              selectedAccounts={selectedAccounts}
              handleFieldChange={handleFieldChange}
              handleSearchAccount={handleSearchAccount}
              isAccountsLoading={isAccountsLoading}
            />
          </div>
          <div className="d-flex justify-content-end mt-3">
            <Button type="dashed" onClick={add} color="secondary">
              <Icon type="plus" /> Add Split Account
            </Button>
          </div>
        </div>
        <div className="footer mt-5">
          {splitType === "percentage" &&
            (restSplitPercentage < 0 ? (
              <div className="ml-4">Total Split Percentage should be 100.</div>
            ) : (
              <p className="m-0">Total Split Percentage should be 100. Remaining value = {restSplitPercentage} %</p>
            ))}
          <div className="btn-div">
            <Button
              // disabled={splitType === "percentage" ? restSplitPercentage != 0 : false}
              disabled={disableSave()}
              loading={isSubmitting}
              className="ml-auto"
              htmlType="submit"
              type="primary"
            >
              Save
            </Button>
          </div>
        </div>
      </Spin>
    </SplitAccountsConfigWrapper>
  );
};

SplitAccountConfigurationForm = Form.create()(SplitAccountConfigurationForm);
export { SplitAccountConfigurationForm };
